import styles from "../../assets/styles/AppHome/Audit.module.scss";
import React, { useState } from "react";
import { MimaText, AppPage, MimaButton, MimaNewFilter } from "../../components";
import BusinessAdminTable from "./BusinessAdminTable";
import MimaAdminTable from "./MimaAdminTable";

const Audit = ({
  mimaAdminTable,
  busAdminTable,
  goToBusAdminTable,
  goToMimaAdminTable,
}) => {
  const [showFilter, setShowFilter] = useState(false);
  const [filterQuery, setFilterQuery] = useState("");

  const filterByData = [{ value: "Date", key: "createdAt" }];
  const filterHandler = async (query) => {
    setFilterQuery(query);
  };
  return (
    <AppPage pageTitle="Activity Tracking">
      <div>
        <div className={styles.recent}>
          <MimaText mt={4} variant="bodyBold" align="center">
            You are viewing{" "}
            {busAdminTable ? "Signed up Businesses" : "MIMA Admin"}
          </MimaText>

          <div className={styles.main_nav}>
            <div
              className={
                busAdminTable
                  ? styles.main_nav_item_active
                  : styles.main_nav_item
              }
              onClick={goToBusAdminTable}
            >
              Signed up Businesses
            </div>
            <div
              className={
                mimaAdminTable
                  ? styles.main_nav_item_active
                  : styles.main_nav_item
              }
              onClick={goToMimaAdminTable}
            >
              MIMA Admin
            </div>
          </div>
          <div className={styles.filterSection}>
            <div>
              <MimaButton
                title={showFilter ? "Close Filter" : "Filter"}
                onClick={() => setShowFilter(!showFilter)}
                mt={2}
              />
            </div>
          </div>
          <MimaNewFilter
            showFilter={showFilter}
            setShowFilter={setShowFilter}
            filterByData={filterByData}
            filterHandler={filterHandler}
          />
        </div>

        <>
          {busAdminTable && (
            <>
              <BusinessAdminTable filterQuery={filterQuery} />
            </>
          )}
          {mimaAdminTable && (
            <>
              <MimaAdminTable filterQuery={filterQuery} />
            </>
          )}
        </>
      </div>
    </AppPage>
  );
};
export default Audit;
